<template>
  <div class="hello" style="height: 100vh;" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <GlobalHeader style="position: absolute;" :activeIndex="activeIndex" />
    <el-main>
      <div class="gray-background">
        <div class="white-background">
          <!-- 内容 -->
          <div class="center">
            <div class="max">
              <div class="container">
                <span class="tab" @click="selectTab(1)" :class="{ active: currentTab === 1 }">当年数据</span>
                <span class="tab" @click="selectTab(2)" :class="{ active: currentTab === 2 }">历年签单</span>
                <span class="tab" @click="selectTab(3)" :class="{ active: currentTab === 3 }">历年回款</span>
                <span class="tab" @click="selectTab(4)" :class="{ active: currentTab === 4 }">历年未回</span>
                <span class="tab" @click="selectTab(5)" :class="{ active: currentTab === 5 }">历年数量</span>
                <span class="tab" @click="selectTab(6)" :class="{ active: currentTab === 6 }">回款周期</span>
              </div>

              <div class="numEvt" v-if="currentTab != 6">
                <span @click="clearEvt" style="border:1px solid #d1d1d1;cursor: pointer;height: 35px;"> All</span>
                <el-select class="container_box" v-model="staff" filterable placeholder="市场人员" @change="staffChange"
                  style="margin-left: 6px;width: 150px;height: 30px;" clearable>
                  <el-option v-for="(item, index) in staff_one" :key="index" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
                <el-select class="container_box" v-model="region" filterable placeholder="客户地区" @change="regionChange"
                  style="margin-left: 6px;width: 150px;height: 30px;" clearable>
                  <el-option v-for="(item, index) in region_one" :key="index" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
                <el-select v-if="currentTab === 1" v-model="year" @change="year_type" placeholder="请选择"
                  style="width: 150px;height: 30px;">
                  <el-option v-for="option in options1" :key="option.value" :label="option.label"
                    :value="{ value: option.value, label: option.label }"></el-option>
                </el-select>
              </div>
            </div>
            <div class="tabs" style="margin-top: 30px;">
              <div class="tab-content" v-if="currentTab === 1">
                <div style="display: flex;">
                  <div style="display: flex;">
                    <el-table :data="amountData" style="width:100%;height: 385px;">
                      <el-table-column prop="name" label="产品类型" width="100" align="left"></el-table-column>
                      <el-table-column prop="sum" label="合计" width="120" align="left">
                        <template slot-scope="props">
                          <span class="span_one" :style="getStyle(props.row.sum)">{{ props.row.sum }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="ratio" label="同比" width="80" align="left">
                        <template slot-scope="props">
                          <span class="span_one" :style="{ color: props.row.ratio === '0%' ? '#d1d1d1' : '#000' }">
                            {{ props.row.ratio !== '' ? props.row.ratio + '%' : '' }}
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="flex: 1; display: flex; justify-content: flex-end;">
                      <div ref="chart" style="width:1000px; height: 400px;"></div>
                    </div>
                  </div>
                  <div ref="pieChart" style="width: 400px; height: 300px;margin-top:80px;margin-left:-40px">
                  </div>
                </div>
                <div style="display: flex;">
                  <div style="display: flex;">
                    <el-table :data="regionData" style="width: 100%">
                      <el-table-column prop="name" label="客户地区" width="100">
                      </el-table-column>
                      <el-table-column prop="sum" label="合计" width="120">
                        <template slot-scope="props">
                          <span class="span_one" :style="getStyle(props.row.sum)">{{ props.row.sum }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="ratio" label="同比" width="80">
                        <template slot-scope="props">
                          <span class="span_one" :style="{ color: props.row.ratio === '0%' ? '#d1d1d1' : '#000' }">
                            {{ props.row.ratio !== '' ? props.row.ratio + '%' : '' }}
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="flex: 1; display: flex; justify-content: flex-end;">
                      <div ref="chart_two" style="width:1000px; height: 400px;"></div>
                    </div>
                    <div ref="pieChart_two" style="width: 400px; height: 300px;margin-top:80px;margin-left:-40px">
                    </div>
                  </div>
                </div>
                <div style="display: flex;">
                  <div style="display: flex;">
                    <el-table :data="signData" style="width: 100%">
                      <el-table-column prop="name" label="市场人员" width="100">
                      </el-table-column>
                      <el-table-column prop="sum" label="合计" width="120">
                        <template slot-scope="props">
                          <span class="span_one" :style="getStyle(props.row.sum)">{{ props.row.sum }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="ratio" label="同比" width="80">
                        <template slot-scope="props">
                          <span class="span_one" :style="{ color: props.row.ratio === '0%' ? '#d1d1d1' : '#000' }">
                            {{ props.row.ratio !== '' ? props.row.ratio + '%' : '' }}
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="flex: 1; display: flex; justify-content: flex-end;">
                      <div ref="chart_three" style="width:1000px; height: 400px;"></div>
                    </div>
                  </div>
                  <div ref="pieChart_three" style="width: 400px; height: 300px;margin-top:80px;margin-left:-40px">
                  </div>
                </div>
              </div>
              <div class="tab-content" v-if="currentTab === 2">
                <div style="display: flex;">
                  <div style="display: flex;">
                    <el-table :data="all_year_amount" style="width: 100% ;height: 385px;">
                      <el-table-column prop="name" label="产品类型" width="100">
                      </el-table-column>
                      <el-table-column prop="sum" label="合计" width="120">
                        <template slot-scope="props">
                          <span class="span_one" :style="getStyle(props.row.sum)">{{ props.row.sum }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="flex: 1; display: flex; justify-content: flex-end;">
                      <div ref="arr_chart" style="width:1000px; height: 400px;"></div>
                    </div>
                  </div>
                  <div ref="arr_pieChart" style="width: 400px; height: 300px;margin-top:80px;margin-left:-40px"></div>
                </div>
                <div style="display: flex;">
                  <div style="display: flex;">
                    <el-table :data="all_year_region" style="width: 100%">
                      <el-table-column prop="name" label="客户地区" width="100">
                      </el-table-column>
                      <el-table-column prop="sum" label="合计" width="120">
                        <template slot-scope="props">
                          <span class="span_one" :style="getStyle(props.row.sum)">{{ props.row.sum }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="flex: 1; display: flex; justify-content: flex-end;">
                      <div ref="arr_two_chart" style="width:1000px; height: 400px;"></div>
                    </div>
                    <div ref="arr_two_pieChart" style="width: 400px; height: 300px;margin-top:80px;margin-left:-40px">
                    </div>
                  </div>
                </div>
                <div style="display: flex;">
                  <div style="display: flex;">
                    <el-table :data="all_year_sign" style="width: 100%">
                      <el-table-column prop="name" label="市场人员" width="100">
                      </el-table-column>
                      <el-table-column prop="sum" label="合计" width="120">
                        <template slot-scope="props">
                          <span class="span_one" :style="getStyle(props.row.sum)">{{ props.row.sum }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="flex: 1; display: flex; justify-content: flex-end;">
                      <div ref="arr_three_chart" style="width:1000px; height: 400px;"></div>
                    </div>
                  </div>
                  <div ref="arr_three_pieChart" style="width: 400px; height: 300px;margin-top:80px;margin-left:-40px">
                  </div>
                </div>
              </div>
              <div class="tab-content" v-if="currentTab === 3">
                <div style="display: flex;">
                  <div style="display: flex;">
                    <el-table :data="all_back_amount" style="width: 100% ;height: 385px;">
                      <el-table-column prop="name" label="产品类型" width="100">
                      </el-table-column>
                      <el-table-column prop="sum" label="合计" width="120">
                        <template slot-scope="props">
                          <span class="span_one" :style="getStyle(props.row.sum)">{{ props.row.sum }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="flex: 1; display: flex; justify-content: flex-end;">
                      <div ref="arr_back_chart" style="width:1000px; height: 400px;"></div>
                    </div>
                  </div>
                  <div ref="arr_back_pieChart" style="width: 400px; height: 300px;margin-top:80px;margin-left:-40px">
                  </div>
                </div>
                <div style="display: flex;">
                  <div style="display: flex;">
                    <el-table :data="all_back_region" style="width: 100%">
                      <el-table-column prop="name" label="产品类型" width="100">
                      </el-table-column>
                      <el-table-column prop="sum" label="合计" width="120">
                        <template slot-scope="props">
                          <span class="span_one" :style="getStyle(props.row.sum)">{{ props.row.sum }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="flex: 1; display: flex; justify-content: flex-end;">
                      <div ref="arr_region_chart" style="width:1000px; height: 400px;"></div>
                    </div>
                    <div ref="arr_region_pieChart"
                      style="width: 400px; height: 300px;margin-top:80px;margin-left:-40px">
                    </div>
                  </div>
                </div>
                <div style="display:flex">
                  <div style="display:flex">
                    <el-table :data="all_back_sign" style="width: 100%">
                      <el-table-column prop="name" label="产品类型" width="100">
                      </el-table-column>
                      <el-table-column prop="sum" label="合计" width="120">
                        <template slot-scope="props">
                          <span class="span_one" :style="getStyle(props.row.sum)">{{ props.row.sum }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="flex: 1; display: flex; justify-content: flex-end;">
                      <div ref="arr_sign_chart" style="width:1000px; height: 400px;"></div>
                    </div>
                  </div>
                  <div ref="arr_sign_pieChart" style="width: 400px; height: 300px;margin-top:80px;margin-left:-40px">
                  </div>
                </div>
              </div>
              <div class="tab-content" v-if="currentTab === 4">
                <div style="display:flex">
                  <div style="display:flex">
                    <el-table :data="all_wait_amount" style="width: 100% ;height: 385px;">
                      <el-table-column prop="name" label="产品类型" width="100">
                      </el-table-column>
                      <el-table-column prop="sum" label="合计" width="120">
                        <template slot-scope="props">
                          <span class="span_one" :style="getStyle(props.row.sum)">{{ props.row.sum }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="flex: 1; display: flex; justify-content: flex-end;">
                      <div ref="wait_chart" style="width:1000px; height: 400px;"></div>
                    </div>
                  </div>
                  <div ref="wait_pieChart" style="width: 400px; height: 300px;margin-top:80px;margin-left:-40px">
                  </div>
                </div>
                <div style="display:flex">
                  <div style="display:flex">
                    <el-table :data="all_wait_region" style="width: 100%">
                      <el-table-column prop="name" label="产品类型" width="100">
                      </el-table-column>
                      <el-table-column prop="sum" label="合计" width="120">
                        <template slot-scope="props">
                          <span class="span_one" :style="getStyle(props.row.sum)">{{ props.row.sum }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="flex: 1; display: flex; justify-content: flex-end;">
                      <div ref="wait_region_chart" style="width:1000px; height: 400px;"></div>
                    </div>
                    <div ref="wait_region_pieChart"
                      style="width: 400px; height: 300px;margin-top:80px;margin-left:-40px">
                    </div>
                  </div>
                </div>
                <div style="display:flex">
                  <div style="display:flex">
                    <el-table :data="all_wait_sign" style="width: 100%">
                      <el-table-column prop="name" label="产品类型" width="100">
                      </el-table-column>
                      <el-table-column prop="sum" label="合计" width="120">
                        <template slot-scope="props">
                          <span class="span_one" :style="getStyle(props.row.sum)">{{ props.row.sum }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="flex: 1; display: flex; justify-content: flex-end;">
                      <div ref="wait_sign_chart" style="width:1000px; height: 400px;"></div>
                    </div>
                  </div>
                  <div ref="wait_sign_pieChart" style="width: 400px; height: 300px;margin-top:80px;margin-left:-40px">
                  </div>
                </div>
              </div>
              <div class="tab-content" v-if="currentTab === 5">
                <div style="display:flex">
                  <div style="display:flex">
                    <el-table :data="all_count_amount" style="width: 100% ;height: 385px;">
                      <el-table-column prop="name" label="产品类型" width="100">
                      </el-table-column>
                      <el-table-column prop="sum" label="合计" width="120">
                        <template slot-scope="props">
                          <span class="span_one" :style="getStyle(props.row.sum)">{{ props.row.sum }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="flex: 1; display: flex; justify-content: flex-end;">
                      <div ref="count_amount_chart" style="width:1000px; height: 400px;"></div>
                    </div>
                  </div>
                  <div ref="count_amount_pieChart"
                    style="width: 400px; height: 300px;margin-top:80px;margin-left:-40px">
                  </div>
                </div>
                <div style="display:flex">
                  <div style="display:flex">
                    <el-table :data="all_count_region" style="width: 100%">
                      <el-table-column prop="name" label="产品类型" width="100">
                      </el-table-column>
                      <el-table-column prop="sum" label="合计" width="120">
                        <template slot-scope="props">
                          <span class="span_one" :style="getStyle(props.row.sum)">{{ props.row.sum }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="flex: 1; display: flex; justify-content: flex-end;">
                      <div ref="count_region_chart" style="width:1000px; height: 400px;"></div>
                    </div>
                    <div ref="count_region_pieChart"
                      style="width: 400px; height: 300px;margin-top:80px;margin-left:-40px">
                    </div>
                  </div>
                </div>
                <div style="display:flex">
                  <div style="display:flex">
                    <el-table :data="all_count_sign" style="width: 100%" :summary-method="getSummaries">
                      <el-table-column prop="name" label="产品类型" width="100">
                      </el-table-column>
                      <el-table-column prop="sum" label="合计" width="120">
                        <template slot-scope="props">
                          <span class="span_one" :style="getStyle(props.row.sum)">{{ props.row.sum }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div style="flex: 1; display: flex; justify-content: flex-end;">
                      <div ref="count_sign_chart" style="width:1000px; height: 400px;"></div>
                    </div>
                  </div>
                  <div ref="count_sign_pieChart" style="width: 400px; height: 300px;margin-top:80px;margin-left:-40px">
                  </div>
                </div>
              </div>
              <div class="tab-content" v-if="currentTab === 6">
                <div>
                  <el-table :data="period_region" style="width: 100% ;">
                    <el-table-column prop="name" label="客户地区" width="100">
                    </el-table-column>
                    <el-table-column prop="back_period" label="回款周期" width="120">
                      <template slot-scope="props">
                        <span class="span_one" :style="getStyle(props.row.back_period)">{{ props.row.back_period
                          }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="unback_period" label="未回周期" width="120">
                      <template slot-scope="props">
                        <span class="span_one" :style="getStyle(props.row.unback_period)">{{ props.row.unback_period
                          }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="undo_amount" label="未完工" width="120">
                      <template slot-scope="props">
                        <span class="span_one" :style="getStyle(props.row.undo_amount)">{{ props.row.undo_amount
                          }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="finish_unback" label="已完工">
                      <template slot-scope="props">
                        <span class="span_one" :style="getStyle(props.row.finish_unback)">{{ props.row.finish_unback
                          }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div>
                  <el-table :data="period_sign" style="width: 100%" :summary-method="getSummaries">
                    <el-table-column prop="name" label="市场人员" width="100">
                    </el-table-column>
                    <el-table-column prop="backed_days" label="回款周期" width="120">
                      <template slot-scope="props">
                        <span class="span_one" :style="getStyle(props.row.backed_days)">{{ props.row.backed_days
                          }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="unback_day" label="未回周期" width="120">
                      <template slot-scope="props">
                        <span class="span_one" :style="getStyle(props.row.unback_day)">{{ props.row.unback_day }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="undo_amount" label="未完工" width="120">
                      <template slot-scope="props">
                        <span class="span_one" :style="getStyle(props.row.undo_amount)">{{ props.row.undo_amount
                          }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="finish_unback" label="已完工">
                      <template slot-scope="props">
                        <span :style="getStyle(props.row.finish_unback)">{{ props.row.finish_unback }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-main>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import GlobalHeader from '@/components/GlobalHeader.vue'
import { ERPIndexApi, ERPSearchApi } from "@/api/report/index.js";




export default {
  components: {
    GlobalHeader
  },
  data() {

    return {
      activeIndex: "11",
      currentTab: 1,
      tableData: [],
      amountData: [{}],
      regionData: [],
      signData: [],
      //历年签单
      all_year_amount: [],
      all_year_region: [],
      all_year_sign: [],
      //历年回款
      all_back_amount: [],
      all_back_region: [],
      all_back_sign: [],
      //历年未回
      all_wait_amount: [],
      all_wait_region: [],
      all_wait_sign: [],

      //历年数量
      all_count_amount: [],
      all_count_region: [],
      all_count_sign: [],
      //回款周期
      period_region: [],
      period_sign: [],

      //region
      region: null,
      staff: null,
      region_one: null,
      staff_one: null,
      year: {
        value: '10',
        label: '2026'
      },

      options1: [
        { value: '10', label: '2026' }, // 将2025放在最前面
        { value: '9', label: '2025' }, // 将2025放在最前面
        { value: '8', label: '2024' },
        { value: '7', label: '2023' },
        { value: '6', label: '2022' },
        { value: '5', label: '2021' },
        { value: '4', label: '2020' },
        { value: '3', label: '2019' },
        { value: '2', label: '2018' },
        { value: '1', label: '2017' }],
      loading: false,
    };

  },
  created() {
    this.loading = true
    ERPIndexApi({
      year: this.year.label,
    }).then((res => {
      this.amountData = res.data.this_year.amount;
      this.regionData = res.data.this_year.region
      this.signData = res.data.this_year.sign
      //历年签单
      this.all_year_amount = res.data.all_year.amount;
      this.all_year_region = res.data.all_year.region
      this.all_year_sign = res.data.all_year.sign

      //all_back  历年回款
      this.all_back_amount = res.data.all_back.amount;
      this.all_back_region = res.data.all_back.region
      this.all_back_sign = res.data.all_back.sign

      //all_wait  历年未回
      this.all_wait_amount = res.data.all_wait.amount;
      this.all_wait_region = res.data.all_wait.region
      this.all_wait_sign = res.data.all_wait.sign

      //历年数量
      this.all_count_amount = res.data.all_count.amount;
      this.all_count_region = res.data.all_count.region
      this.all_count_sign = res.data.all_count.sign
      //period  //回款周期
      this.period_region = res.data.period.region
      this.period_sign = res.data.period.sign


      let arr = res.data.this_year.amount_chart;
      let arr_two = res.data.this_year.region_chart;
      let arr_three = res.data.this_year.sign_chart;
      this.echarts_one = arr.slice(1, 8)
      this.echarts_two = arr_two.slice(1, 20)
      this.echarts_three = arr_three.slice(1, 20)
      //当年数据 产品类型
      this.echarts_one = this.echarts_one.map(val => {
        return {
          name: val[0],
          type: 'line',
          data: val.slice(1, 13)
        }
      })
      //当年数据 客户地区
      this.echarts_two = this.echarts_two.map(val => {
        return {
          name: val[0],
          type: 'line',
          data: val.slice(1, 13)
        }
      })
      //当年数据 客户地区
      this.echarts_three = this.echarts_three.map(val => {
        return {
          name: val[0],
          type: 'line',
          data: val.slice(1, 13)
        }
      })
      let all_year = res.data.all_year.amount_chart;
      let all_year_two = res.data.all_year.region_chart;
      let all_year_three = res.data.all_year.sign_chart;

      this.echartsArr_one = all_year.slice(1, 8)
      this.echartsArr_two = all_year_two.slice(1, 20)
      this.echartsArr_three = all_year_three.slice(1, 20)
      //历年签单 产品类型
      this.echartsArr_one = this.echartsArr_one.map(val => {
        return {
          name: val[0], // 将每个数组的第一个元素作为name属性的值
          type: 'line',
          data: val.slice(1) // 将除第一个元素外的其他元素作为data属性的值
        }
      })

      //历年签单 客户地区
      this.echartsArr_two = this.echartsArr_two.map(val => {
        return {
          name: val[0],
          type: 'line',
          data: val.slice(1)
        }
      })
      //历年签单 客户地区
      this.echartsArr_three = this.echartsArr_three.map(val => {
        return {
          name: val[0],
          type: 'line',
          data: val.slice(1, 13)
        }
      })

      //历年回款all_back
      let all_back = res.data.all_back.amount_chart;
      let all_back_two = res.data.all_back.region_chart;
      let all_back_three = res.data.all_back.sign_chart;

      this.all_back_one = all_back.slice(1, 8)
      this.all_back_two = all_back_two.slice(1, 20)
      this.all_back_three = all_back_three.slice(1, 20)


      this.all_back_one = this.all_back_one.map(val => {
        return {
          name: val[0],
          type: 'line',
          data: val.slice(1, 13)
        }
      })
      //历年签单 客户地区
      this.all_back_two = this.all_back_two.map(val => {
        return {
          name: val[0],
          type: 'line',
          data: val.slice(1, 13)
        }
      })
      //历年签单 客户地区
      this.all_back_three = this.all_back_three.map(val => {
        return {
          name: val[0],
          type: 'line',
          data: val.slice(1, 13)
        }
      })

      //历年回款all_back
      let all_wait = res.data.all_wait.amount_chart;
      let all_wait_two = res.data.all_wait.region_chart;
      let all_wait_three = res.data.all_wait.sign_chart;

      this.all_wait_one = all_wait.slice(1, 8)
      this.all_wait_two = all_wait_two.slice(1, 20)
      this.all_wait_three = all_wait_three.slice(1, 20)

      this.all_wait_one = this.all_wait_one.map(val => {
        return {
          name: val[0],
          type: 'line',
          data: val.slice(1, 13)
        }
      })
      //历年未回 客户地区
      this.all_wait_two = this.all_wait_two.map(val => {
        return {
          name: val[0],
          type: 'line',
          data: val.slice(1, 13)
        }
      })
      //历年未回 客户地区
      this.all_wait_three = this.all_wait_three.map(val => {
        return {
          name: val[0],
          type: 'line',
          data: val.slice(1, 13)
        }
      })

      //历年数量
       let all_count = res.data.all_count.amount_chart;
      let all_count_two = res.data.all_count.region_chart;
      let all_count_three = res.data.all_count.sign_chart;

      this.all_count_one = all_count.slice(1, 8)
      this.all_count_two = all_count_two.slice(1, 20)
      this.all_count_three = all_count_three.slice(1, 20)

      this.all_count_one = this.all_count_one.map(val => {
        return {
          name: val[0],
          type: 'line',
          data: val.slice(1, 13)
        }
      })
      //历年数量 客户地区
      this.all_count_two = this.all_count_two.map(val => {
        return {
          name: val[0],
          type: 'line',
          data: val.slice(1, 13)
        }
      })
      //历年数量 客户地区
      this.all_count_three = this.all_count_three.map(val => {
        return {
          name: val[0],
          type: 'line',
          data: val.slice(1, 13)
        }
      })
      this.loading = false;
      //当年数据
      this.initChart();
      this.initChart_tow();
      this.initChart_three();
      ERPSearchApi({}).then((res => {
        this.region_one = res.data.region
        this.staff_one = res.data.staff
      }))
    }))
  },
  mounted() {
    //当年数据
    this.initChart();
    this.initChart_tow();
    this.initChart_three();
  },


  methods: {
    //当年签单
    initChart() {
      const chartDom = this.$refs.chart;
      const myChart1 = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          source: this.echarts_one
        },
        xAxis: {
          type: 'category',
          data: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
        },
        yAxis: {
          type: 'value',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        series: this.echarts_one
      };
      const pieChart = echarts.init(this.$refs.pieChart)
      pieChart.setOption({
        series: [{
          type: 'pie',
          data: this.amountData.map((item, index) => {
            if (item.name !== "总计") {
              return {
                value: item.sum,
                name: item.name
              };
            }
          }),

          minShowLabelAngle: 10 // 设置最小显示角度阈值为10度
        }],
        tooltip: {
            formatter: '{b}: {c}({d}%)' // 提示框内容格式化，{b}表示name，{c}表示value
        }
      })
      myChart1.setOption(option);
    },
    initChart_tow() {
      const chartDom = this.$refs.chart_two;
      const myChart2 = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          source: this.echarts_two
        },
        xAxis: {
          type: 'category',
          data: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
        },
        yAxis: {
          type: 'value',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        series: this.echarts_two
      };
      const pieChart = echarts.init(this.$refs.pieChart_two)
      pieChart.setOption({
        series: [{
          type: 'pie',
           data: this.regionData.map((item, index) => {
            if (item.name !== "总计") {
              return {
                value: item.sum,
                name: item.name
              };
            }
          }),
          minShowLabelAngle: 10 // 设置最小显示角度阈值为10度
        }],
        tooltip: {
          formatter: '{b}: {c}({d}%)' // 提示框内容格式化，{b}表示name，{c}表示value
        }
      })
      myChart2.setOption(option);
    },
    initChart_three() {
      const chartDom = this.$refs.chart_three;
      const myChart3 = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          source: this.echarts_three
        },
        xAxis: {
          type: 'category',
          data: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
        },
        yAxis: {
          type: 'value',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        series: this.echarts_three
      };
      const pieChart = echarts.init(this.$refs.pieChart_three)
      pieChart.setOption({
        series: [{
          type: 'pie',
           data: this.signData.map((item, index) => {
            if (item.name !== "总计") {
              return {
                value: item.sum,
                name: item.name
              };
            }
          }),
          minShowLabelAngle: 10 // 设置最小显示角度阈值为10度
        }],
        tooltip: {
           formatter: '{b}: {c}({d}%)' // 提示框内容格式化，{b}表示name，{c}表示value
        }
      })
      myChart3.setOption(option);
    },
    //历年签单
    allChart_all() {
      const chartDom = this.$refs.arr_chart;
      const myChart4 = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          source: this.echartsArr_one
        },
        xAxis: {
          type: 'category',
          data: ['2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025','2026']
        },
        yAxis: {
          type: 'value',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        series: this.echartsArr_one
      };
      const pieChart = echarts.init(this.$refs.arr_pieChart)
      pieChart.setOption({
        series: [{
          type: 'pie',
          data: this.all_year_amount.map((item, index) => {
            if (item.name !== "总计") {
              return {
                value: item.sum,
                name: item.name
              };
            }
          }),
          minShowLabelAngle: 10 // 设置最小显示角度阈值为10度
        }],
        tooltip: {
            formatter: '{b}: {c}({d}%)' // 提示框内容格式化，{b}表示name，{c}表示value
        }
      })
      myChart4.setOption(option);
    },
    allChart_all_two() {
      const chartDom = this.$refs.arr_two_chart;
      const myChart5 = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          source: this.echartsArr_two
        },
        xAxis: {
          type: 'category',
          data: ['2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024','2025','2026']
        },
        yAxis: {
          type: 'value',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        series: this.echartsArr_two
      };
      const pieChart = echarts.init(this.$refs.arr_two_pieChart)
      pieChart.setOption({
        series: [{
          type: 'pie',
          data: this.all_year_region.map((item, index) => {
            if (item.name !== "总计") {
              return {
                value: item.sum,
                name: item.name
              };
            }
          }),
          minShowLabelAngle: 10 // 设置最小显示角度阈值为10度
        }],
        tooltip: {
            formatter: '{b}: {c}({d}%)' // 提示框内容格式化，{b}表示name，{c}表示value
        }
      })
      myChart5.setOption(option);
    },
    allChart_all_three() {
      const chartDom = this.$refs.arr_three_chart;
      const myChart6 = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          source: this.echartsArr_three
        },
        xAxis: {
          type: 'category',
         data: ['2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024','2025','2026']
        },
        yAxis: {
          type: 'value',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        series: this.echartsArr_three
      };
      const pieChart = echarts.init(this.$refs.arr_three_pieChart)
      pieChart.setOption({
        series: [{
          type: 'pie',
           data: this.all_year_sign.map((item, index) => {
            if (item.name !== "总计") {
              return {
                value: item.sum,
                name: item.name
              };
            }
          }),
          minShowLabelAngle: 10 // 设置最小显示角度阈值为10度
        }],
        tooltip: {
            formatter: '{b}: {c}({d}%)' // 提示框内容格式化，{b}表示name，{c}表示value
        }
      })
      myChart6.setOption(option);
    },


    //历年回款
    allChart_back() {
      const chartDom = this.$refs.arr_back_chart;
      const myChart7 = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          source: this.all_back_one
        },
        xAxis: {
          type: 'category',
          data: ['2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024','2025','2026']
        },
        yAxis: {
          type: 'value',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        series: this.all_back_one
      };
      const pieChart = echarts.init(this.$refs.arr_back_pieChart)
      pieChart.setOption({
        series: [{
          type: 'pie',
           data: this.all_back_amount.map((item, index) => {
            if (item.name !== "总计") {
              return {
                value: item.sum,
                name: item.name
              };
            }
          }),

          minShowLabelAngle: 10 // 设置最小显示角度阈值为10度
        }],
        tooltip: {
           formatter: '{b}: {c}({d}%)' // 提示框内容格式化，{b}表示name，{c}表示value
        }
      })
      myChart7.setOption(option);
    },
    allChart_back_two() {
      const chartDom = this.$refs.arr_region_chart;
      const myChart8 = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          source: this.all_back_two
        },
        xAxis: {
          type: 'category',
          data: ['2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024','2025','2026']
        },
        yAxis: {
          type: 'value',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        series: this.all_back_two
      };
      const pieChart = echarts.init(this.$refs.arr_region_pieChart)
      pieChart.setOption({
        series: [{
          type: 'pie',
           data: this.all_back_region.map((item, index) => {
            if (item.name !== "总计") {
              return {
                value: item.sum,
                name: item.name
              };
            }
          }),
          minShowLabelAngle: 10 // 设置最小显示角度阈值为10度
        }],
        tooltip: {
            formatter: '{b}: {c}({d}%)' // 提示框内容格式化，{b}表示name，{c}表示value
        }
      })
      myChart8.setOption(option);
    },
    allChart_back_three() {
      const chartDom = this.$refs.arr_sign_chart;
      const myChart9 = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          source: this.all_back_three
        },
        xAxis: {
          type: 'category',
          data: ['2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024','2025','2026']
        },
        yAxis: {
          type: 'value',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        series: this.all_back_three
      };
      const pieChart = echarts.init(this.$refs.arr_sign_pieChart)
      pieChart.setOption({
        series: [{
          type: 'pie',
          data: this.all_back_sign.map((item, index) => {
            if (item.name !== "总计") {
              return {
                value: item.sum,
                name: item.name
              };
            }
          }),
          minShowLabelAngle: 10 // 设置最小显示角度阈值为10度
        }],
        tooltip: {
            formatter: '{b}: {c}({d}%)' // 提示框内容格式化，{b}表示name，{c}表示value
        }
      })
      myChart9.setOption(option);
    },
    //历年未回
    allChart_wait() {
      const chartDom = this.$refs.wait_chart;
      const myChart10 = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          source: this.all_wait_one
        },
        xAxis: {
          type: 'category',
           data: ['2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024','2025','2026']
        },
        yAxis: {
          type: 'value',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        series: this.all_wait_one
      };
      const pieChart = echarts.init(this.$refs.wait_pieChart)
      pieChart.setOption({
        series: [{
          type: 'pie',
          data: this.all_wait_amount.map((item, index) => {
            if (item.name !== "总计") {
              return {
                value: item.sum,
                name: item.name
              };
            }
          }),
          minShowLabelAngle: 10 // 设置最小显示角度阈值为10度
        }],
        tooltip: {
            formatter: '{b}: {c}({d}%)' // 提示框内容格式化，{b}表示name，{c}表示value
        }
      })
      myChart10.setOption(option);
    },

    allChart_wait_two() {
      const chartDom = this.$refs.wait_region_chart;
      const myChart11 = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          source: this.all_wait_two
        },
        xAxis: {
          type: 'category',
          data: ['2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024','2025','2026']
        },
        yAxis: {
          type: 'value',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        series: this.all_wait_two
      };
      const pieChart = echarts.init(this.$refs.wait_region_pieChart)
      pieChart.setOption({
        series: [{
          type: 'pie',
          data: this.all_wait_region.map((item, index) => {
            if (item.name !== "总计") {
              return {
                value: item.sum,
                name: item.name
              };
            }
          }),
          minShowLabelAngle: 10 // 设置最小显示角度阈值为10度
        }],
        tooltip: {
            formatter: '{b}: {c}({d}%)' // 提示框内容格式化，{b}表示name，{c}表示value
        }
      })
      myChart11.setOption(option);
    },

    allChart_wait_three() {
      const chartDom = this.$refs.wait_sign_chart;
      const myChart12 = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          source: this.all_wait_three
        },
        xAxis: {
          type: 'category',
         data: ['2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024','2025','2026']
        },
        yAxis: {
          type: 'value',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        series: this.all_wait_three
      };
      const pieChart = echarts.init(this.$refs.wait_sign_pieChart)
      pieChart.setOption({
        series: [{
          type: 'pie',
           data: this.all_wait_sign.map((item, index) => {
            if (item.name !== "总计") {
              return {
                value: item.sum,
                name: item.name
              };
            }
          }),
          minShowLabelAngle: 10 // 设置最小显示角度阈值为10度
        }],
        tooltip: {
            formatter: '{b}: {c}({d}%)' // 提示框内容格式化，{b}表示name，{c}表示value
        }
      })
      myChart12.setOption(option);
    },



    //历年数量
   allChart_count() {
      const chartDom = this.$refs.count_amount_chart;
      const myChart13 = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          source: this.all_count_one
        },
        xAxis: {
          type: 'category',
          data: ['2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024','2025','2026']
        },
        yAxis: {
          type: 'value',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        series: this.all_count_one
      };
      const pieChart = echarts.init(this.$refs.count_amount_pieChart)
      pieChart.setOption({
        series: [{
          type: 'pie',
           data: this.all_count_amount.map((item, index) => {
            if (item.name !== "总计") {
              return {
                value: item.sum,
                name: item.name
              };
            }
          }),
          minShowLabelAngle: 10 // 设置最小显示角度阈值为10度
        }],
        tooltip: {
            formatter: '{b}: {c}({d}%)' // 提示框内容格式化，{b}表示name，{c}表示value
        }
      })
      myChart13.setOption(option);
    },
    allChart_count_two() {
      const chartDom = this.$refs.count_region_chart;
      const myChart14 = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          source: this.all_count_two
        },
        xAxis: {
          type: 'category',
          data: ['2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024','2025','2026']
        },
        yAxis: {
          type: 'value',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        series: this.all_count_two
      };
      const pieChart = echarts.init(this.$refs.count_region_pieChart)
      pieChart.setOption({
        series: [{
          type: 'pie',
          data: this.all_count_region.map((item, index) => {
            if (item.name !== "总计") {
              return {
                value: item.sum,
                name: item.name
              };
            }
          }),
          minShowLabelAngle: 10 // 设置最小显示角度阈值为10度
        }],
        tooltip: {
            formatter: '{b}: {c}({d}%)' // 提示框内容格式化，{b}表示name，{c}表示value
        }
      })
      myChart14.setOption(option);
    },
    allChart_count_three() {
      const chartDom = this.$refs.count_sign_chart;
      const myChart15 = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          source: this.all_count_three
        },
        xAxis: {
          type: 'category',
          data: ['2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024','2025','2026']
        },
        yAxis: {
          type: 'value',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        series: this.all_count_three
      };
      const pieChart = echarts.init(this.$refs.count_sign_pieChart)
      pieChart.setOption({
        series: [{
          type: 'pie',
          data: this.all_count_sign.map((item, index) => {
            if (item.name !== "总计") {
              return {
                value: item.sum,
                name: item.name
              };
            }
          }),
          minShowLabelAngle: 10 // 设置最小显示角度阈值为10度
        }],
        tooltip: {
            formatter: '{b}: {c}({d}%)' // 提示框内容格式化，{b}表示name，{c}表示value
        }
      })
      myChart15.setOption(option);
    },

    getStyle(value) {
      return {
        color: value == '0' ? '#d1d1d1' : '#000',
      };
    },

    selectTab(tab) {
      this.currentTab = tab;
      if (this.currentTab ==1) {
          this.$nextTick(()=>{
             //当年数据
            this.initChart();
            this.initChart_tow();
            this.initChart_three();
          })
      }else if(this.currentTab == 2){
         this.$nextTick(()=>{
               //历年签单
              this.allChart_all();
              this.allChart_all_two();
              this.allChart_all_three();
          })
      } else if (this.currentTab == 3) {
       this.$nextTick(() => {
          //历年回款
          this.allChart_back()
          this.allChart_back_two()
          this.allChart_back_three()
        })
      } else if (this.currentTab == 4) {
       this.$nextTick(() => {
          //历年未回
          this.allChart_wait()
          this.allChart_wait_two()
          this.allChart_wait_three()
        })
      } else if (this.currentTab == 5) {
        this.$nextTick(() => {
          //历年数量
          this.allChart_count()
          this.allChart_count_two()
          this.allChart_count_three()
        })
      }
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总价';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += ' 元';
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    },
    staffChange(value) {
      this.staff = value;
      this.getList()
    },
    regionChange(value) {
      this.region = value;
      this.getList()
    },
    //客户类型
    year_type(selectedValues) {
      this.year.label = selectedValues.label;
      this.getList();
    },

    //获取页面数据
    getList() {
      this.loading = true
      let data = {
        region: this.region ? this.region : '',
        staff: this.staff ? this.staff : '',
        year: this.year.label,
      };
      ERPIndexApi(data).then((res) => {
        this.amountData = res.data.this_year.amount;
        this.regionData = res.data.this_year.region
        this.signData = res.data.this_year.sign

        this.all_year_amount = res.data.all_year.amount;
        this.all_year_region = res.data.all_year.region
        this.all_year_sign = res.data.all_year.sign

        //all_back  历年回款
        this.all_back_amount = res.data.all_back.amount;
        this.all_back_region = res.data.all_back.region
        this.all_back_sign = res.data.all_back.sign
        //all_wait  历年未回
        this.all_wait_amount = res.data.all_wait.amount;
        this.all_wait_region = res.data.all_wait.region
        this.all_wait_sign = res.data.all_wait.sign
        //历年数量
        this.all_count_amount = res.data.all_count.amount;
        this.all_count_region = res.data.all_count.region
        this.all_count_sign = res.data.all_count.sign
        //period  //回款周期

        this.period_region = res.data.period.region
        this.period_sign = res.data.period.sign
        this.loading = false;


        let arr = res.data.this_year.amount_chart;
        let arr_two = res.data.this_year.region_chart;
        let arr_three = res.data.this_year.sign_chart;
        this.echarts_one = arr.slice(1, 8)
        this.echarts_two = arr_two.slice(1, 20)
        this.echarts_three = arr_three.slice(1, 20)
        //当年数据 产品类型
        this.echarts_one = this.echarts_one.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })
        //当年数据 客户地区
        this.echarts_two = this.echarts_two.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })
        //当年数据 客户地区
        this.echarts_three = this.echarts_three.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })
        let all_year = res.data.all_year.amount_chart;
        let all_year_two = res.data.all_year.region_chart;
        let all_year_three = res.data.all_year.sign_chart;

        this.echartsArr_one = all_year.slice(1, 8)
        this.echartsArr_two = all_year_two.slice(1, 20)
        this.echartsArr_three = all_year_three.slice(1, 20)
        //历年签单 产品类型
        this.echartsArr_one = this.echartsArr_one.map(val => {
          return {
            name: val[0], // 将每个数组的第一个元素作为name属性的值
            type: 'line',
            data: val.slice(1,13) // 将除第一个元素外的其他元素作为data属性的值
          }
        })

        //历年签单 客户地区
        this.echartsArr_two = this.echartsArr_two.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1,13)
          }
        })
        //历年签单 客户地区
        this.echartsArr_three = this.echartsArr_three.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })

        //历年回款all_back
        let all_back = res.data.all_back.amount_chart;
        let all_back_two = res.data.all_back.region_chart;
        let all_back_three = res.data.all_back.sign_chart;

        this.all_back_one = all_back.slice(1,3)
        this.all_back_two = all_back_two.slice(1, 20)
        this.all_back_three = all_back_three.slice(1, 20)


        this.all_back_one = this.all_back_one.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })
        //历年签单 客户地区
        this.all_back_two = this.all_back_two.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })
        //历年签单 客户地区
        this.all_back_three = this.all_back_three.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })

        //历年未回
        let all_wait = res.data.all_wait.amount_chart;
        let all_wait_two = res.data.all_wait.region_chart;
        let all_wait_three = res.data.all_wait.sign_chart;

        this.all_wait_one = all_wait.slice(1, 8)
        this.all_wait_two = all_wait_two.slice(1, 20)
        this.all_wait_three = all_wait_three.slice(1, 20)

        this.all_wait_one = this.all_wait_one.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })
        //历年未回 客户地区
        this.all_wait_two = this.all_wait_two.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })
        //历年未回 客户地区
        this.all_wait_three = this.all_wait_three.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })

         //历年数量
        let all_count = res.data.all_count.amount_chart;
        let all_count_two = res.data.all_count.region_chart;
        let all_count_three = res.data.all_count.sign_chart;

        this.all_count_one = all_count.slice(1, 8)
        this.all_count_two = all_count_two.slice(1, 20)
        this.all_count_three = all_count_three.slice(1, 20)

        this.all_count_one = this.all_count_one.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })
        //历年数量 客户地区
        this.all_count_two = this.all_count_two.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })
        //历年数量 客户地区
        this.all_count_three = this.all_count_three.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })

        // this.loading = false;
            //当年数据
        if (this.currentTab == 1) {
          this.$nextTick(() => {
            //当年数据   获取数据的时候清除之前的数据
            echarts.dispose(this.$refs.chart);
            echarts.dispose(this.$refs.pieChart);
            echarts.dispose(this.$refs.chart_two);
            echarts.dispose(this.$refs.pieChart_two);
            echarts.dispose(this.$refs.pieChart_three);
            echarts.dispose(this.$refs.chart_three);
            this.initChart();
            this.initChart_tow();
            this.initChart_three();
          })
        } else if (this.currentTab == 2) {
          this.$nextTick(() => {
            //历年签单
              echarts.dispose(this.$refs.arr_chart);
              echarts.dispose(this.$refs.arr_pieChart);
              echarts.dispose(this.$refs.arr_two_chart);
              echarts.dispose(this.$refs.arr_two_pieChart);
              echarts.dispose(this.$refs.arr_three_chart);
              echarts.dispose(this.$refs.arr_three_pieChart);

              this.allChart_all();
              this.allChart_all_two();
              this.allChart_all_three();
          })
        } else if (this.currentTab == 3) {
          this.$nextTick(() => {
            //历年回款
            echarts.dispose(this.$refs.arr_back_chart);
            echarts.dispose(this.$refs.arr_back_pieChart);
            echarts.dispose(this.$refs.arr_region_chart);
            echarts.dispose(this.$refs.arr_region_pieChart);
            echarts.dispose(this.$refs.arr_sign_chart);
            echarts.dispose(this.$refs.arr_sign_pieChart);
            this.allChart_back()
            this.allChart_back_two()
            this.allChart_back_three()
          })
        } else if (this.currentTab == 4) {
          this.$nextTick(() => {
            //历年未回
              echarts.dispose(this.$refs.wait_chart);
              echarts.dispose(this.$refs.wait_pieChart);
              echarts.dispose(this.$refs.wait_region_pieChart);
              echarts.dispose(this.$refs.wait_region_chart);
              echarts.dispose(this.$refs.wait_sign_pieChart);
              echarts.dispose(this.$refs.wait_sign_chart);
               this.allChart_wait()
              this.allChart_wait_two()
              this.allChart_wait_three()
          })
        } else if (this.currentTab == 5) {
          this.$nextTick(() => {
            //历年数量
            echarts.dispose(this.$refs.count_amount_chart);
            echarts.dispose(this.$refs.count_amount_pieChart);
            echarts.dispose(this.$refs.count_region_pieChart);
            echarts.dispose(this.$refs.count_region_chart);
            echarts.dispose(this.$refs.count_sign_chart);
            echarts.dispose(this.$refs.count_sign_pieChart);

            this.allChart_count()
            this.allChart_count_two()
            this.allChart_count_three()
          })
        }
      });
    },
    clearEvt() {
      this.region = ''
      this.staff = ''
      this.year = '2026'
      this.loading = true;
      ERPIndexApi({
        year: '2026',
      }).then((res => {
        this.amountData = res.data.this_year.amount;
        this.regionData = res.data.this_year.region
        this.signData = res.data.this_year.sign

        this.all_year_amount = res.data.all_year.amount;
        this.all_year_region = res.data.all_year.region
        this.all_year_sign = res.data.all_year.sign

        //all_back  历年回款
        this.all_back_amount = res.data.all_back.amount;
        this.all_back_region = res.data.all_back.region
        this.all_back_sign = res.data.all_back.sign

        //all_wait  历年未回
        this.all_wait_amount = res.data.all_wait.amount;
        this.all_wait_region = res.data.all_wait.region
        this.all_wait_sign = res.data.all_wait.sign

        //all_wait  历年未回
        this.all_count_amount = res.data.all_count.amount;
        this.all_count_region = res.data.all_count.region
        this.all_count_sign = res.data.all_count.sign
        //period  //回款周期

        this.period_region = res.data.period.region
        this.period_sign = res.data.period.sign



       let arr = res.data.this_year.amount_chart;
        let arr_two = res.data.this_year.region_chart;
        let arr_three = res.data.this_year.sign_chart;
        this.echarts_one = arr.slice(1, 8)
        this.echarts_two = arr_two.slice(1, 20)
        this.echarts_three = arr_three.slice(1, 20)
        //当年数据 产品类型
        this.echarts_one = this.echarts_one.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })
        //当年数据 客户地区
        this.echarts_two = this.echarts_two.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })
        //当年数据 客户地区
        this.echarts_three = this.echarts_three.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })
        let all_year = res.data.all_year.amount_chart;
        let all_year_two = res.data.all_year.region_chart;
        let all_year_three = res.data.all_year.sign_chart;

        this.echartsArr_one = all_year.slice(1, 8)
        this.echartsArr_two = all_year_two.slice(1, 20)
        this.echartsArr_three = all_year_three.slice(1,20)
        //历年签单 产品类型
        this.echartsArr_one = this.echartsArr_one.map(val => {
          return {
            name: val[0], // 将每个数组的第一个元素作为name属性的值
            type: 'line',
            data: val.slice(1) // 将除第一个元素外的其他元素作为data属性的值
          }
        })

        //历年签单 客户地区
        this.echartsArr_two = this.echartsArr_two.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1)
          }
        })
        //历年签单 客户地区
        this.echartsArr_three = this.echartsArr_three.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })

        //历年回款all_back
        let all_back = res.data.all_back.amount_chart;
        let all_back_two = res.data.all_back.region_chart;
        let all_back_three = res.data.all_back.sign_chart;

        this.all_back_one = all_back.slice(1, 8)
        this.all_back_two = all_back_two.slice(1, 20)
        this.all_back_three = all_back_three.slice(1, 20)


        this.all_back_one = this.all_back_one.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })
        //历年签单 客户地区
        this.all_back_two = this.all_back_two.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })
        //历年签单 客户地区
        this.all_back_three = this.all_back_three.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })

        //历年回款all_back
        let all_wait = res.data.all_wait.amount_chart;
        let all_wait_two = res.data.all_wait.region_chart;
        let all_wait_three = res.data.all_wait.sign_chart;

        this.all_wait_one = all_wait.slice(1, 8)
        this.all_wait_two = all_wait_two.slice(1, 20)
        this.all_wait_three = all_wait_three.slice(1, 20)

        this.all_wait_one = this.all_wait_one.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })
        //历年未回 客户地区
        this.all_wait_two = this.all_wait_two.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })
        //历年未回 客户地区
        this.all_wait_three = this.all_wait_three.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })

        //历年数量
        let all_count = res.data.all_count.amount_chart;
        let all_count_two = res.data.all_count.region_chart;
        let all_count_three = res.data.all_count.sign_chart;

        this.all_count_one = all_count.slice(1, 8)
        this.all_count_two = all_count_two.slice(1, 20)
        this.all_count_three = all_count_three.slice(1, 20)

        this.all_count_one = this.all_count_one.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })
        //历年数量 客户地区
        this.all_count_two = this.all_count_two.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })
        //历年数量 客户地区
        this.all_count_three = this.all_count_three.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })



        // this.loading = false;
        //当年数据
        if (this.currentTab == 1) {
          this.$nextTick(() => {
            //当年数据
            this.initChart();
            this.initChart_tow();
            this.initChart_three();
          })
        } else if (this.currentTab == 2) {

          this.$nextTick(() => {
            //历年签单
            this.allChart_all();
            this.allChart_all_two();
            this.allChart_all_three();
            console.log(122);
          })
        } else if (this.currentTab == 3) {
          this.$nextTick(() => {
            //历年回款

            this.allChart_back()
            this.allChart_back_two()
            this.allChart_back_three()
          })
        } else if (this.currentTab == 4) {
          this.$nextTick(() => {
            //历年未回
            this.allChart_wait()
            this.allChart_wait_two()
            this.allChart_wait_three()
          })
        } else if (this.currentTab == 5) {
          this.$nextTick(() => {
            // //历年数量
            this.allChart_count()
            this.allChart_count_two()
            this.allChart_count_three()
          })
        }
        this.loading = false;

        ERPSearchApi({}).then((res => {
          this.region_one = res.data.region
          this.staff_one = res.data.staff
        }))
      }))
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../../style/space.less");

.el-main {
  left: 160px;
  /* 与左侧项目管理列表的宽度保持一致 */
  padding: 0px;
  /* 添加一些内边距，使内容不紧贴在边缘 */
  top: 50px;
  position: relative;
}

.gray-background {
  background-color: #ccc;
  height: 100vh;
  display: flex;
}

.white-background {
  background-color: #fff;
  height: 95.5%;
  margin-left: 0%;
  overflow-y: scroll;
  width: 91%;
  .container {
    border: 1px solid #d1d1d1;
    border-radius: 5px;
  }
  .center {    width: 100%;
    height: 100%;
    margin: 0 auto 10px 10px;
    .max {
      display: flex;
      justify-content: space-between;
      top: 50px;
      padding: 10px 10px;
      position: fixed;
      z-index: 999;
      width: 88%;
      background-color: #fff;
      left: 180px;
      min-width: 1200px;
    }
    span {
      font-size: 14px;
      border-left: 1px solid #d1d1d1;
      padding: 0px 10px;
    }

    span:nth-child(1) {
      border-left: none;
    }
  }
}
.span_one{
    padding:0px !important;
}

.numEvt {
  span:nth-last-of-type(1) {
    border: 1px solid #d1d1d1;
    padding: 7.5px 20px;
    border-radius: 5px;
  }

  span:nth-last-of-type(2) {
    border: 1px solid #d1d1d1;
    padding: 5px 20px;
    border-radius: 5px;
    margin: 0px 10px;
  }

  span:nth-last-of-type(3) {
    border: 1px solid #d1d1d1 !important;
    padding: 5px 20px;
    border-radius: 5px;
  }

  /deep/.el-input__inner {
    height: 35px !important;
    line-height: 35px !important;
  }
}

.container .tab {
  color: #d1d1d1;
  /* 未选中状态的字体颜色为灰色 */
  margin-top: 5px;
}

.container .tab.active {
  color: black;
  /* 选中状态的字体颜色为黑色 */
}

.tabs {
  .tab-content {
    height: 100%;
    overflow: auto;

    .el-table {
      border: 1px solid #d1d1d1;
    }

    div {
      margin: 20px 0 0 0;
      padding: 0 10px;
      border-radius: 5px;
      // display: block !important;
    }
  }
}

.tab{
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/src/Business_report/index.vue